import { TextField } from "@mui/material";
import { ChangeEvent } from "react";
interface props {
	name: string;
	value: number | string | null | undefined;
	min?: number;
	max?: number;
	width?: number;
	handleChange: (event: ChangeEvent<HTMLInputElement>) => Promise<void>;
}

export const InputNumber = ({
	name,
	value,
	min,
	max,
	width,
	handleChange
}: props) => {
	const safeValue = value == null ? "" : value;

	return (
		<TextField
			type="number"
			value={safeValue}
			name={name}
			onChange={handleChange}
			variant="standard"
			slotProps={{
				inputLabel: {
					shrink: true
				},
				htmlInput: {
					min,
					max
				}
			}}
			size="small"
			style={width ? { width } : undefined}
		/>
	);
};
